import type { DescriptorType } from '../../types/descriptor.types';

function isEmptyHeadline(descriptor: DescriptorType): boolean {
    return descriptor.type === 'headline' && descriptor.label.trim() === '';
}

export function getDescriptorSections(descriptors: readonly DescriptorType[]): DescriptorType[][] {
    const firstDynamic = descriptors.findIndex((descriptor) => descriptor.dynamicField);
    const body = firstDynamic === -1 ? [] : descriptors.slice(firstDynamic);
    const sections: DescriptorType[][] = [];
    let current: DescriptorType[] = [];
    let sawSeparator = false;

    for (let position = 0; position < body.length;) {
        if (isEmptyHeadline(body[position]) && position + 1 < body.length && isEmptyHeadline(body[position + 1])) {
            if (current.length > 0) {
                sections.push(current);
            }
            current = [];
            sawSeparator = true;
            position += 2;
        } else {
            current.push(body[position]);
            position += 1;
        }
    }
    if (current.length > 0) {
        sections.push(current);
    }
    return sawSeparator ? sections : [descriptors.slice()];
}
